import { useState } from "react";
import { useNavigate } from "react-router-dom";

export const CatGameWallpaper = () => {
  const navigate = useNavigate();
  const [loadedImages, setLoadedImages] = useState<Set<number>>(new Set());

  const wallpapers = [
    { id: 1, src: "/images/catgame/wallpapers/1.png" },
    { id: 2, src: "/images/catgame/wallpapers/2.png" },
    { id: 3, src: "/images/catgame/wallpapers/3.png" },
    { id: 4, src: "/images/catgame/wallpapers/4.png" },
  ];

  const handleDownload = (imageSrc: string, filename: string) => {
    const link = document.createElement("a");
    link.href = imageSrc;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleImageLoad = (index: number) => {
    setLoadedImages((prev) => new Set(prev).add(index));
  };

  return (
    <div className="py-3 mx-6">
      <div className="mb-3">
        <div
          className="flex gap-1 items-center mb-2 cursor-pointer"
          onClick={() => navigate("/rewards/catgame")}
        >
          <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.09375 4.8125L2.90625 11L9.09375 17.1875"
              stroke="black"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>

          <div className="text-xl font-bold leading-none text-black">
            CatGame wallpapers
          </div>
        </div>

        <p className="text-[#626262] text-sm">
          Download your High Quality JPEG CatGame wallpapers for phone
        </p>
      </div>

      <div>
        <div className="grid grid-cols-2 gap-4">
          {wallpapers.map((wallpaper, index) => (
            <div
              key={wallpaper.id}
              className="relative shadow-lg rounded-[10px] border border-gray-200 overflow-hidden"
            >
              {/* Skeleton loader */}
              {!loadedImages.has(index) && (
                <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-pulse rounded-[10px]" />
              )}

              <img
                src={wallpaper.src}
                alt={`CatGame Wallpaper ${wallpaper.id}`}
                className={`transition-opacity cursor-pointer hover:opacity-90 rounded-[10px] max-h-[229px] object-cover w-full ${
                  loadedImages.has(index) ? "opacity-100" : "opacity-0"
                }`}
                loading="lazy"
                onLoad={() => handleImageLoad(index)}
              />

              <button
                className="flex absolute right-2 left-2 bottom-2 gap-1 items-center justify-center bg-[#00000026] rounded-lg w-full max-w-[144px] py-1 mx-auto backdrop-blur-lg"
                onClick={() =>
                  handleDownload(wallpaper.src, `catgame-wallpaper-${wallpaper.id}.png`)
                }
              >
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6 7.70361V2.70361M9.75 7.70361V9.37028C9.75 9.59129 9.6622 9.80325 9.50592 9.95954C9.34964 10.1158 9.13768 10.2036 8.91667 10.2036H3.08333C2.86232 10.2036 2.65036 10.1158 2.49408 9.95954C2.3378 9.80325 2.25 9.59129 2.25 9.37028V7.70361"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M3.9165 5.62012L5.99984 7.70345L8.08317 5.62012"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>

                <span className="text-white text-[8px]">Download</span>
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CatGameWallpaper;
